// The functions of this template are used in byod_app_form.js and mmg_app_form.js to enable to show and hide
export function handleShowPasswordIconButtonPress(showPasswordIconButton, showPw=false) {
    if (showPasswordIconButton !== null && showPasswordIconButton.parentNode !== null) {
        // needed Elements for functions
        const pwContainer = showPasswordIconButton.parentNode
        const hidePasswordIconButton = pwContainer.querySelector(".hidePasswordIconButtons")
        const passwordValue = pwContainer.querySelector(".password").innerHTML
        const displayedWifiPassword = pwContainer.querySelector(".wifiPassword")

        if (hidePasswordIconButton !== null && passwordValue !== null && displayedWifiPassword !== null) {
            showPasswordIconButton.addEventListener("click", function () {
                // displayedWifiPassword.innerHTML = passwordValue
                // showPasswordIconButton.classList.add('hidden')
                // hidePasswordIconButton.classList.remove('hidden')
                showPassword(showPasswordIconButton, hidePasswordIconButton, displayedWifiPassword, passwordValue)
            })

            hidePasswordIconButton.addEventListener("click", function () {
                // showPasswordIconButton.classList.remove('hidden')
                // hidePasswordIconButton.classList.add('hidden')
                // const regex = /./g;
                // displayedWifiPassword.innerHTML = passwordValue.replaceAll(regex, '*')
                hidePassword(showPasswordIconButton, hidePasswordIconButton, displayedWifiPassword, passwordValue)
            });
            // The default values in the html are hiding the pw
            if(showPw){
                showPassword(showPasswordIconButton, hidePasswordIconButton, displayedWifiPassword, passwordValue)
            }
        }
    }
}

function showPassword(showPasswordIconButton, hidePasswordIconButton, displayedWifiPassword, passwordValue){
    displayedWifiPassword.innerHTML = passwordValue
    showPasswordIconButton.classList.add('hidden')
    hidePasswordIconButton.classList.remove('hidden')
}

function hidePassword(showPasswordIconButton, hidePasswordIconButton, displayedWifiPassword, passwordValue){
    showPasswordIconButton.classList.remove('hidden')
    hidePasswordIconButton.classList.add('hidden')
    const regex = /./g;
    displayedWifiPassword.innerHTML = passwordValue.replaceAll(regex, '*')
}

export function handleAllShowPasswordIconButtonPress() {
    const showPasswordIconButtons = document.getElementsByClassName('showPasswordIconButtons')
    for (let showPasswordIconButton of showPasswordIconButtons) {
        handleShowPasswordIconButtonPress(showPasswordIconButton)
    }
}